/*
  EUROVEXA Custom Gallery Auto-Slide (DRAFT THEME TEST BUILD)
  - Does NOT modify media-gallery.js or product-media-gallery.liquid.
  - Reuses existing thumbnail button click handlers already wired by media-gallery.js
    (clicking a thumbnail's <button> triggers the theme's own setActiveMedia/sync logic).
  - Zoom/lightbox and variant-image sync are untouched (separate systems).

  BUGFIX (this revision): programmatic .click() calls made by advance() bubble up to
  thumbList's click listener, which was incorrectly treated as a manual user interaction
  and paused the auto-slide after every single advance. An isAutoAdvancing flag now lets
  the click listener distinguish real user clicks from auto-advance clicks, so only real
  user interaction pauses/resumes the timer.
*/
(function () {
  var AUTO_SLIDE_INTERVAL = 4500; // 4.5s (within requested 4-5s range)
  var RESUME_DELAY_AFTER_MANUAL = 3000; // wait 3s after manual interaction before resuming

  function initGallery(gallery) {
    if (gallery.dataset.autoSlideInit) return;
    gallery.dataset.autoSlideInit = 'true';

    var thumbList = gallery.querySelector('.thumbnail-list');
    if (!thumbList) return; // single-image product or thumbnails hidden: nothing to auto-slide

    var timer = null;
    var resumeTimeout = null;
    var paused = false;
    var isAutoAdvancing = false; // true only while advance() is programmatically clicking

    function getThumbItems() {
      return Array.prototype.slice.call(thumbList.querySelectorAll('.thumbnail-list__item'));
    }

    function getActiveIndex(items) {
      for (var i = 0; i < items.length; i++) {
        var btn = items[i].querySelector('button');
        if (btn && btn.getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function updateVisualEffect() {
      var items = getThumbItems();
      var activeIndex = getActiveIndex(items);
      items.forEach(function (li, i) {
        li.classList.remove('thumb--active', 'thumb--near');
        if (i === activeIndex) {
          li.classList.add('thumb--active');
        } else if (Math.abs(i - activeIndex) === 1) {
          li.classList.add('thumb--near');
        }
      });
    }

    function advance() {
      if (paused) return;
      var items = getThumbItems();
      if (items.length < 2) return;
      var activeIndex = getActiveIndex(items);
      var nextIndex = (activeIndex + 1) % items.length; // seamless loop back to 0
      var nextButton = items[nextIndex].querySelector('button');
      if (!nextButton) return;
      isAutoAdvancing = true;
      nextButton.click(); // reuses existing theme sync logic fully
      isAutoAdvancing = false;
    }

    function startTimer() {
      stopTimer();
      timer = setInterval(advance, AUTO_SLIDE_INTERVAL);
    }

    function stopTimer() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function pauseTemporarily() {
      paused = true;
      if (resumeTimeout) clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(function () { paused = false; }, RESUME_DELAY_AFTER_MANUAL);
    }

    gallery.addEventListener('mouseenter', function () { paused = true; });
    gallery.addEventListener('mouseleave', function () { paused = false; });

    gallery.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    gallery.addEventListener('touchend', pauseTemporarily, { passive: true });

    thumbList.addEventListener('click', function () {
      if (isAutoAdvancing) return; // ignore clicks we triggered ourselves
      pauseTemporarily();
    });
    var sliderButtons = gallery.querySelectorAll('.slider-buttons .slider-button');
    sliderButtons.forEach(function (btn) { btn.addEventListener('click', pauseTemporarily); });

    var observer = new MutationObserver(function () { updateVisualEffect(); });
    getThumbItems().forEach(function (li) {
      var btn = li.querySelector('button');
      if (btn) observer.observe(btn, { attributes: true, attributeFilter: ['aria-current'] });
    });

    updateVisualEffect();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    startTimer();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
